import { useIntl } from 'react-intl';
import { IconChartBar } from '@rossum/ui/icons/tabler';
import {
  alpha,
  Button,
  Link,
  Stack,
  SvgIcon,
  Theme,
  Typography,
} from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

type Props = {
  link: string;
};

export const LIST_SIDEBAR_WIDTH = 300;
export const getDisabledOverlayBgColor = (t: Theme) =>
  alpha(t.palette.background.default, 0.7);

const DisabledOverlay = ({ link }: Props) => {
  const intl = useIntl();
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={3}
      sx={{
        position: 'fixed',
        left: LIST_SIDEBAR_WIDTH,
        p: 4,
        right: 0,
        top: 0,
        bottom: 0,
        textAlign: 'center',
        backgroundColor: getDisabledOverlayBgColor,
        color: 'text.primary',
        zIndex: 4,
      }}
    >
      <Stack
        sx={{
          background: t => t.palette.action.disabled,
          width: 48,
          height: 48,
          borderRadius: borderRadius('xl'),
        }}
        alignItems="center"
        justifyContent="center"
      >
        <SvgIcon fontSize="large" sx={{ color: 'primary.main' }}>
          <IconChartBar />
        </SvgIcon>
      </Stack>
      <Stack spacing={1}>
        <Typography variant="h6">
          {intl.formatMessage({ id: 'containers.statistics.disabled.title' })}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {intl.formatMessage({ id: 'containers.statistics.disabled.text' })}
        </Typography>
      </Stack>

      <Button
        component={Link}
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        variant="contained"
        size="small"
      >
        {intl.formatMessage({ id: 'containers.statistics.disabled.button' })}
      </Button>
    </Stack>
  );
};

export default DisabledOverlay;
